import React, {createRef, FormEvent, useCallback, useEffect, useState} from 'react';
import {useMapsLibrary} from "@vis.gl/react-google-maps";
import {useAutocompleteSuggestions} from "./use-autocomplete-suggestions";
import {useOnClickOutside} from "usehooks-ts";

interface Props {
    onPlaceSelect: (place: google.maps.places.Place | null) => void;
    value: string;
    placeHolder?: string;
    required?: boolean;
}

// NB : value est la dernière valeur cochée par l'utilisateur
export const GMapAutocompleteCustom = ({
                                           onPlaceSelect
                                           , value
                                           , placeHolder
                                           , required = false
                                       }: Props) => {
    const ref: any = createRef();
    const places = useMapsLibrary('places');

    // NB : inputValue est la valeur actuellement traitée pour l'affichage de suggestions
    const [inputValue, setInputValue] = useState<string>('');
    const {suggestions, resetSession} = useAutocompleteSuggestions(inputValue);
    // NB : est-ce que l'adresse a été validée ?
    const [validated, setValidated] = useState(false);

    const handleInput = useCallback((event: FormEvent<HTMLInputElement>) => {
        setInputValue((event.target as HTMLInputElement).value);
        setValidated(false);
    }, []);

    useEffect(() => {
        setValidated(true);
        console.log("value=", value);
    }, [value]);

    useOnClickOutside(ref, () => {
        resetSession();
    })

    const handleSuggestionClick = useCallback(
        async (suggestion: google.maps.places.AutocompleteSuggestion) => {
            if (!places) return;
            if (!suggestion.placePrediction) return;

            const place = suggestion.placePrediction.toPlace();

            await place.fetchFields({
                fields: [
                    'formattedAddress',
                    'displayName',
                    'viewport',
                    'location',
                    'svgIconMaskURI',
                    'iconBackgroundColor'
                ]
            });

            setInputValue('');

            // calling fetchFields invalidates the session-token, so we now have to call
            // resetSession() so a new one gets created for further search
            resetSession();

            onPlaceSelect(place);
            setValidated(true);
        },
        [places, onPlaceSelect]
    );

    return (
        <div className="autocomplete-container" ref={ref}>
            <textarea
                rows={2}
                value={validated ? value : inputValue}
                className="block p-2.5 w-full text-sm text-white-900 disabled:opacity-65 bg-white bg-opacity-10 rounded-lg border border-gray-500 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                onInput={event => handleInput(event)}
                placeholder={placeHolder}
                required={required}
            />

            {suggestions.length > 0 && (
                <ul className="custom-list z-40 absolute bg-[#33393C] border-solid border-[1px] border-t-[0px]  rounded-b-lg">
                    {suggestions.map((suggestion, index) => {
                        return (
                            <li
                                key={index}
                                className="custom-list-item text-white text-sm py-2 px-4 hover:bg-gray-700 cursor-pointer"
                                onClick={() => handleSuggestionClick(suggestion)}>
                                {suggestion.placePrediction?.text.text}
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};